import { render, staticRenderFns } from "./TableB.vue?vue&type=template&id=10b96dc7"
import script from "./TableB.vue?vue&type=script&lang=js"
export * from "./TableB.vue?vue&type=script&lang=js"
import style0 from "./TableB.vue?vue&type=style&index=0&id=10b96dc7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports